import React, { useEffect } from 'react';
import HeaderButton from '../layouts/HeaderButton';
import { header } from '../../profile';

const Header = () => {

    useEffect(() => {
        if (localStorage.getItem('mode') === 'Dark') {
            const sw = document.getElementById('mode-switch');
            if (sw) sw.checked = true;
            document.documentElement.classList.add('dark-mode');
            const notDark = document.getElementById('not-dark');
            const notEl  = document.getElementById('not');
            if (notDark) notDark.classList.add('inverse-dark');
            if (notEl)   notEl.classList.add('inverse-dark');
            const imgs = document.getElementsByClassName('img-pro');
            for (let i = 0; i < imgs.length; i += 1) {
                imgs.item(i).classList.add('inverse-dark');
            }
        }
    }, []);

    const scrollTo = () => {
        window.scrollTo({ top: 100000, left: 0, behavior: 'smooth' });
    };

    const toggleDarkMode = () => {
        document.documentElement.classList.toggle('dark-mode');
        document.getElementById('not-dark').classList.toggle('inverse-dark');
        document.getElementById('not').classList.toggle('inverse-dark');
        var x = document.getElementsByClassName('img-pro');
        for (let i = 0; i < x.length; i += 1) {
            x.item(i).classList.toggle('inverse-dark');
        }
        if (document.documentElement.classList.contains('dark-mode'))
            localStorage.setItem('mode', 'Dark');
        else
            localStorage.setItem('mode', 'Light');
    };

    return (
        <div>
            <div className="Header">
                <h1>{`${header.name}`}</h1>
                <p className="line-1 anim-typewriter">Software Engineer</p>
                <label className="switch">
                    <input id="mode-switch" onClick={toggleDarkMode} type="checkbox" />
                    <span className="slider round"></span>
                </label>
                <HeaderButton />
            </div>
            <img
                id="not-dark"
                onClick={scrollTo}
                alt="Contact Me"
                title="Contact Me"
                className="gtp"
                src="get in touch.png"
            />
        </div>
    );
};

export default Header;
